/* global $:false */

import 'jquery.slick'

export default class LotsBannerBlock {
  static init () {
    new LotsBannerBlock().init()
  }

  constructor () {
    this._lotBanners = $('.single-lot-banner')
  }

  init () {
    if (this._lotBanners.length < 1) { return }

    this._lotBanners.each((_, lotBanner) => $(lotBanner).slick({
      prevArrow: $(lotBanner).parent().find('.previous'),
      nextArrow: $(lotBanner).parent().find('.next'),
      autoplay: true,
      autoplaySpeed: 10000
    }))
  }
}
